module.exports = __webpack_public_path__ + "c_static/img/C-2淘宝-核对店铺.25f223a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/C-2淘宝-核对店铺.jpg
// module id = U5QC
// module chunks = 33